import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { RouteGuard } from './components/auth/RouteGuard'
import { AdminRoute } from './components/auth/AdminRoute'
import { RoleBasedRedirect } from './components/auth/RoleBasedRedirect'
import { RoleBasedIssuesPage } from './components/auth/RoleBasedIssuesPage'
import { LoginPage } from './pages/auth/LoginPage'
import { RegisterPage } from './pages/auth/RegisterPage'
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage'
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage'
import { SubscriptionPage } from './pages/subscription/SubscriptionPage'
import { SubscriptionSuccessPage } from './pages/subscription/SubscriptionSuccessPage'
import { DashboardPage } from './pages/DashboardPage'
import { DevicesPage } from './pages/DevicesPage'
import { DeviceDetailPage } from './pages/DeviceDetailPage'
import { BillingPage } from './pages/BillingPage'
import { IssueDetailPage } from './pages/IssueDetailPage'
import { UsersPage } from './pages/UsersPage'
import { SettingsPage } from './pages/SettingsPage'
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminDevicesPage } from './pages/admin/AdminDevicesPage'
import { AdminOrganizationDetailPage } from './pages/admin/AdminOrganizationDetailPage'
import { KaseyaSettingsPage } from './pages/admin/KaseyaSettingsPage'
import { AgentDownloadPage } from './pages/agent/AgentDownloadPage'
import { AgentInstallPage } from './pages/agent/AgentInstallPage'
import { AgentSuccessPage } from './pages/agent/AgentSuccessPage'
import { BillingDashboardPage } from './pages/billing/BillingDashboardPage'
import { BillingPaymentsPage } from './pages/billing/BillingPaymentsPage'
import { BillingSubscriptionsPage } from './pages/billing/BillingSubscriptionsPage'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<RoleBasedRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route path="/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
          <Route path="/subscription/success" element={<ProtectedRoute><SubscriptionSuccessPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/devices" element={<RouteGuard><DevicesPage /></RouteGuard>} />
          <Route path="/devices/:deviceId" element={<RouteGuard><DeviceDetailPage /></RouteGuard>} />
          <Route path="/billing" element={<RouteGuard><BillingPage /></RouteGuard>} />
          <Route path="/issues" element={<RouteGuard><RoleBasedIssuesPage /></RouteGuard>} />
          <Route path="/issues/:issueId" element={<RouteGuard><IssueDetailPage /></RouteGuard>} />
          <Route path="/users" element={<RouteGuard><UsersPage /></RouteGuard>} />
          <Route path="/settings" element={<RouteGuard><SettingsPage /></RouteGuard>} />
          <Route path="/invite-users" element={<Navigate to="/users" replace />} />

          <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
          <Route path="/admin/organizations" element={<AdminRoute><AdminUsersPage /></AdminRoute>} />
          <Route path="/admin/users" element={<Navigate to="/admin/organizations" replace />} />
          <Route path="/admin/organizations/:companyId" element={<AdminRoute><AdminOrganizationDetailPage /></AdminRoute>} />
          <Route path="/admin/devices" element={<AdminRoute><AdminDevicesPage /></AdminRoute>} />
          <Route path="/admin/kaseya/settings" element={<AdminRoute><KaseyaSettingsPage /></AdminRoute>} />
          <Route path="/agent/download" element={<AgentDownloadPage />} />
          <Route path="/agent/install" element={<AgentInstallPage />} />
          <Route path="/agent/success" element={<AgentSuccessPage />} />

          <Route path="/billing/dashboard" element={<RouteGuard><BillingDashboardPage /></RouteGuard>} />
          <Route path="/billing/payments" element={<RouteGuard><BillingPaymentsPage /></RouteGuard>} />
          <Route path="/billing/subscriptions" element={<RouteGuard><BillingSubscriptionsPage /></RouteGuard>} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
